import { LitElement, html, css } from 'lit';
import { EventManager } from '../../utilities/events';
import { decodeEntities } from '../../utilities/formsUtilities';
export class AllInMutableHeader extends LitElement {
    static properties = {
        text: { type: String, reflect: true },
        name: { type: String },
        _initialText: { state: true, type: String }
    };
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        this._initialText = this.text;
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-header-${this.name}`, this._handleTextChange);
    }
    render() {
        return html `<span>${this.text}</span><slot></slot>`;
    }
    _handleTextChange(e) {
        if (e.detail.name == this.name) {
            if (e.detail.revert === true) {
                this.text = this._initialText;
            }
            else {
                this.text = decodeEntities(e.detail.text);
            }
        }
    }
    static styles = [
        css `
           :host {
                font-family:var(--allin-font-family,inherit);
                font-size:var(--allin-font-size,1rem);
                color:var(--allin-text-color,#000);
                background-color:var(--allin-bg-color,transparent);
                padding:var(--allin-padding,0);
                font-weight:var(--allin-font-weight,normal);
            }
        `
    ];
}
